<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
})

const formatCurrency = (value) => {
  return new Intl.NumberFormat('th-TH', {
    style: 'currency',
    currency: 'THB',
    minimumFractionDigits: 0,
  }).format(value || 0)
}

const formatDate = (value) => {
  if (!value) return '-'
  return new Intl.DateTimeFormat('th-TH', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(value))
}

const statusText = (status) => {
  const map = { paid: 'ชำระแล้ว', partial: 'ชำระบางส่วน', overdue: 'ค้างชำระ', pending: 'รอชำระ' }
  return map[status] || status
}

const statusBadgeClass = (status) => {
  const map = {
    paid: 'text-bg-success',
    partial: 'text-bg-warning',
    overdue: 'text-bg-danger',
    pending: 'text-bg-secondary',
  }
  return map[status] || 'text-bg-light'
}
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 class="fw-bold mb-1">ประวัติใบแจ้งหนี้</h5>
          <div class="text-muted small">รายการเรียกเก็บย้อนหลังของลูกบ้านรายนี้</div>
        </div>
        <span class="badge text-bg-light border text-dark rounded-pill px-3 py-2">
          {{ items.length }} รายการ
        </span>
      </div>

      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>เลขที่บิล</th>
              <th>รอบบิล</th>
              <th class="text-end">ยอดเงิน</th>
              <th>ครบกำหนด</th>
              <th>สถานะ</th>
            </tr>
          </thead>
          <tbody v-if="items.length">
            <tr v-for="invoice in items" :key="invoice.id">
              <td class="fw-semibold">{{ invoice.id }}</td>
              <td>{{ invoice.billingMonth }}</td>
              <td class="text-end">{{ formatCurrency(invoice.amount) }}</td>
              <td>{{ formatDate(invoice.dueDate) }}</td>
              <td>
                <span class="badge rounded-pill" :class="statusBadgeClass(invoice.status)">
                  {{ statusText(invoice.status) }}
                </span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5" class="text-center py-5 text-muted">
                <i class="bi bi-receipt fs-2 d-block mb-2"></i>
                ยังไม่มีประวัติใบแจ้งหนี้
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
